module.exports = __webpack_public_path__ + "static/media/missed-first.2ec85e9b.svg";